import { Singleton } from '@/decorators';
import { ApiInstance } from './apiInstance';

/**
 * HTTP Service (Framework Agnostic)
 * 
 * Main HTTP service singleton for the application.
 * Use this for general API calls that don't require special authentication.
 */
@Singleton
export class HttpService extends ApiInstance {
  constructor() {
    super();
  }
}
